import { useNotification } from "@zapier/utils";

export function getFriendlyErrorMessage(error: unknown): string {
  let message = "Uh oh, something went wrong.";
  if (error instanceof Error && error.message) {
    message += `\n\`${error.message}\``;
  }
  return message;
}

export function getFriendlyErrorMessageWithErrorCode(error: unknown): string {
  let message: string;
  message = getFriendlyErrorMessage(error);

  const formattedErrorId = extractErrorId(error);
  if (formattedErrorId) message += `\n${formattedErrorId}`;

  return message;
}

export function toastFriendlyErrorMessage(
  error: unknown,
  errorMessageOverride?: string,
) {
  const { createNotification } = useNotification();

  let msgWithErrorCode: string;

  if (errorMessageOverride) {
    msgWithErrorCode = errorMessageOverride;
  } else {
    msgWithErrorCode = getFriendlyErrorMessageWithErrorCode(error);
  }
  return createNotification({ type: "error", message: msgWithErrorCode });
}

export function extractErrorId(error: unknown): string | undefined {
  const errorId = (error as any)?.data?.id || undefined;
  if (errorId) return `\`«${errorId}»\``;
}
